import React, { useEffect, useState } from 'react';
import { Icon } from 'hakobio-react-ui';
import { configMessages } from '../../../lang/messages';
import { CUSTOM_NODES } from '../../../constants/CUSTOM_NODES';
import { useIntl } from 'react-intl';

interface SchemaSUAComponentProps {
  component: any;
  index: number;
}

const SchemaSUAComponent = ({ component, index }: SchemaSUAComponentProps) => {
  const [_schemaHeader, setSchemaHeader] = useState(null);
  const [_schema, setSchema] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    const getSchema = async () => {
      const schema = await schemaHeader.schema();
      setSchema(schema);
    };
    const schemaHeader = CUSTOM_NODES[component.type];
    if (schemaHeader) {
      setSchemaHeader(schemaHeader);
      getSchema();
    }
  }, []);

  const getComponentParameters = () => {
    return Object.entries(_schema.properties).map(([key, property]: [any, any]) => {
      if (
        key === 'name' ||
        key === 'customName' ||
        key === 'anchors' ||
        key === 'instrumentationPorts' ||
        key === 'samplingPorts'
      ) {
        return null;
      }
      const value = component[key];
      if (value) {
        return (
          <div className="f-row f2-center" key={key}>
            <div className="f-row f2-end gap-2" style={{ flexWrap: 'wrap' }}>
              <span className="capitalize anthracite">{property.name}</span>
              <span> &#8226; </span>
              <span className="">
                {value +
                  (property.units
                    ? ' ' + property?.units === 'inch'
                      ? "'"
                      : ' ' + property?.units
                    : '')}
              </span>
            </div>
          </div>
        );
      } else {
        return null;
      }
    });
  };

  const renderAnchorsByType = (componentType: any, shemasType: any) => {
    return componentType.map((a, i) => {
      return Object.entries(shemasType).map(([key, property]: [any, any]) => {
        if (key === 'position') {
          return null;
        }
        if (!a) return null;
        let value = a[key];
        if (!value) return null;
        return (
          <div className="f-row f2-center" key={`${key}-${i}`} style={{ fontSize: 13 }}>
            <div className="f-row f2-end gap-2" style={{ flexWrap: 'wrap' }}>
              <span className="capitalize anthracite">{property.name + (i + 1)}</span>
              <span> &#8226; </span>
              <span className="">{value}</span>
            </div>
          </div>
        );
      });
    });
  };

  function anchorsWithParams(anchors: any) {
    let hasParams = false;
    anchors.forEach((anchor) => {
      if (anchor !== null && anchor !== undefined) {
        Object.keys(anchor).forEach((key) => {
          if (key !== 'position' && key !== 'componentLink' && key !== 'name') {
            hasParams = true;
          }
        });
      }
    });
    return hasParams;
  }

  const renderAnchors = (type: string) => {
    let anchorsList;
    let schemasType;
    if (type === 'anchors' && component?.anchors && anchorsWithParams(component?.anchors)) {
      anchorsList = component?.anchors;
      schemasType = _schema.$defs.anchor.properties;
      return (
        <div>
          <div className="f-row f2-center gap-2 mt-1 mb-0.5" style={{ fontSize: 13 }}>
            <Icon name="liquid" size="0.8rem" color="#187bde" />
            {intl.formatMessage(configMessages.fluidTransfer)}
          </div>
          {renderAnchorsByType(anchorsList, schemasType)}
        </div>
      );
    }
    if (component.type !== 'tubing') {
      if (
        type === 'instrumentationPorts' &&
        component?.instrumentationPorts &&
        anchorsWithParams(component?.instrumentationPorts)
      ) {
        anchorsList = component?.instrumentationPorts;
        schemasType = _schema.$defs.instrumentationPort.properties;
        return (
          <div>
            <div className="f-row f2-center gap-2 mt-1 mb-0.5" style={{ fontSize: 13 }}>
              <Icon name="instrumentation" size="0.8rem" color="#ad5f2e" />
              {intl.formatMessage(configMessages.instrumentationPorts)}
            </div>
            {renderAnchorsByType(anchorsList, schemasType)}
          </div>
        );
      }
      if (
        type === 'samplingPorts' &&
        component?.samplingPorts &&
        anchorsWithParams(component?.samplingPorts)
      ) {
        anchorsList = component?.samplingPorts;
        schemasType = _schema.$defs.samplingPort.properties;
        return (
          <div>
            <div className="f-row f2-center gap-2 mt-1 mb-0.5" style={{ fontSize: 13 }}>
              <Icon name="sampling" size="0.8rem" color="#6a2fad" />
              {intl.formatMessage(configMessages.samplingPorts)}
            </div>
            {renderAnchorsByType(anchorsList, schemasType)}
          </div>
        );
      }
    }
  };

  const render = () => {
    return (
      <div className="f-col" key={`schemaSUAComponent-${index}`} style={{ fontSize: 13 }}>
        <div>
          {component.legendNumber}
          <span className="font-regular"> {_schemaHeader.name} </span>
          <span> &times;{component.count}</span>
        </div>
        {getComponentParameters()}
        {renderAnchors('anchors')}
        {renderAnchors('instrumentationPorts')}
        {renderAnchors('samplingPorts')}
      </div>
    );
  };

  if (!_schema || !_schemaHeader) {
    return null;
  }

  return render();
};

export default SchemaSUAComponent;
